import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Keyboardarrowright } from '@dsny/dsny-component-library/icons';
import { MultiCompanyAccessCompany } from 'src/features/MultiCompanyAccess';
import {
  ArrowWrapper,
  CompanyList,
  CompanyName,
  CompanyRow,
  NoResultsRow,
  PanelCard,
  PanelTop,
  SearchInputStyles,
  SearchTailingStyles,
  SearchWrapperStyles,
  TextFieldWrapper,
} from './CompanySelection.styles';

interface CompanySelectionProps {
  companies: MultiCompanyAccessCompany[];
  selectedCompanyId: number | null;
  onSelectCompany: (company: MultiCompanyAccessCompany) => void;
}

const CompanySelection: React.FC<CompanySelectionProps> = ({
  companies,
  selectedCompanyId,
  onSelectCompany,
}) => {
  const { t } = useTranslation();
  const [searchWord, setSearchWord] = useState<string>('');

  // Filter companies based on search input
  const filteredCompanies = useMemo(
    () =>
      companies.filter((company) =>
        company.business_name.toLowerCase().includes(searchWord.toLowerCase())
      ),
    [companies, searchWord]
  );

  // Handle search input changes
  const handleSearch = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLInputElement;
    setSearchWord(target.value);
  };

  return (
    <PanelCard>
      <PanelTop>
        <TextFieldWrapper
          id="sidebar-company-search"
          name="sidebar-company-search"
          setting="mtr"
          labelText=""
          placeholder={t('MULTI_COMPANY_SEARCH_PLACEHOLDER')}
          width="100%"
          tailingIcon="Search"
          onChange={handleSearch as () => void}
          wrapperStyles={{ ...SearchWrapperStyles }}
          inputStyle={{ ...SearchInputStyles }}
          tailingStyle={{ ...SearchTailingStyles }}
        />
      </PanelTop>

      <CompanyList>
        {filteredCompanies.length > 0 ? (
          filteredCompanies.map((company) => (
            <CompanyRow
              key={company.company_id}
              $isSelected={company.company_id === selectedCompanyId}
              onClick={() => onSelectCompany(company)}
            >
              <CompanyName>{company.business_name}</CompanyName>
              <ArrowWrapper>
                <Keyboardarrowright style={{ width: 16, height: 16 }} />
              </ArrowWrapper>
            </CompanyRow>
          ))
        ) : (
          <NoResultsRow>{t('MULTI_COMPANY_NO_RESULTS')}</NoResultsRow>
        )}
      </CompanyList>
    </PanelCard>
  );
};

export default CompanySelection;
